import { SensitiveDataConfig } from "cohorts/utils/formatParticipantCount";
import { SWRResponse } from "swr";
import { useFetcher } from "~/hooks/useFetcher";

type SensitiveDataConfigResponse = Omit<SWRResponse<SensitiveDataConfig>, "data"> & {
  data: SensitiveDataConfig | null;
};

const useSensitiveDataConfig = (): SensitiveDataConfigResponse => {
  const response = useFetcher<SensitiveDataConfig>("/api/cohort-explorer/settings/sensitive-data", {
    revalidateOnFocus: false,
    revalidateIfStale: false,
    onError: (err) => {
      console.error("Failed to fetch sensitive data config", err);
    },
  });
  return {
    ...response,
    data: response.data ?? null,
  };
};

export default useSensitiveDataConfig;
